// extracted by mini-css-extract-plugin
export default {"header":"Ojzjd2Db6iNzCJjLZ10U","headerText":"i8xd2BL2kj54rPx5pGWj","headerTextDescription":"NL_j2SHJDITrBIu8bRmA","reverseChargeSection":"MPw0ZekT5ontTpEYslN6"};